import { render, staticRenderFns } from "./AdminItem.vue?vue&type=template&id=e3deaa46&scoped=true&"
import script from "./AdminItem.vue?vue&type=script&lang=js&"
export * from "./AdminItem.vue?vue&type=script&lang=js&"
import style0 from "./AdminItem.vue?vue&type=style&index=0&id=e3deaa46&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3deaa46",
  null
  
)

export default component.exports